import React from 'react';
import './loader.css';
const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="loader4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default Loader;
